import { render, staticRenderFns } from "./ResortsSettings.vue?vue&type=template&id=84afcd02&"
import script from "./ResortsSettings.vue?vue&type=script&lang=js&"
export * from "./ResortsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports